import React from 'react';
import { FaEdit, FaTrash, FaCheck } from 'react-icons/fa';
function Todos({ checkHandler, editHandler, deleteHandler, filter }) {
  return (
    <div className="grocery-list">
      {filter.map((todo) => {
        const { id, name, category } = todo;
        return (
          <article className="grocery-item" key={id}>
            <footer>
              <p className={` title ${todo.completed ? 'checked' : ''}`}>
                {name}
              </p>
              <p>{category}</p>
            </footer>
            <div className="btn-container">
              <button
                type="button"
                className="check-btn"
                onClick={() => checkHandler(id)}
              >
                <FaCheck />
              </button>
              <button
                type="button"
                className="edit-btn"
                onClick={() => editHandler(id)}
              >
                <FaEdit />
              </button>
              <button
                type="button"
                className="delete-btn"
                onClick={() => deleteHandler(id)}
              >
                <FaTrash />
              </button>
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default Todos;
